export const TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING =
  'TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING';
export const TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS =
  'TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS';
export const TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING_ERROR =
  'TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING_ERROR';

export const TRANSACTION_HISTORY_REPORT_SITES_LOADING =
  'TRANSACTION_HISTORY_REPORT_SITES_LOADING';
export const TRANSACTION_HISTORY_REPORT_SITES =
  'TRANSACTION_HISTORY_REPORT_SITES';
export const TRANSACTION_HISTORY_REPORT_SITES_LOADING_ERROR =
  'TRANSACTION_HISTORY_REPORT_SITES_LOADING_ERROR';

export const TRANSACTION_HISTORY_REPORT_PRINT_LOADING =
  'TRANSACTION_HISTORY_REPORT_PRINT_LOADING';
export const TRANSACTION_HISTORY_REPORT_EMPTY_RESPONSE =
  'TRANSACTION_HISTORY_REPORT_EMPTY_RESPONSE';
export const TRANSACTION_HISTORY_REPORT_PRINT_LOADING_ERROR =
  'TRANSACTION_HISTORY_REPORT_PRINT_LOADING_ERROR';
export const RESET_TRANSACTION_HISTORY_PRINT_RESPONSE =
  'RESET_TRANSACTION_HISTORY_PRINT_RESPONSE';

export const CLEAR_REPORT_ERROR = 'CLEAR_REPORT_ERROR';
export const TRANSACTION_HISTORY_REPORT = 'TRANSACTION_HISTORY_REPORT';



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/transactionhistoryreport/state/types.js